export const ListQueryKey = 'overflowConfigs';
export const DetailQueryKey = 'overflowConfig';

export const Urls = {
  selectUrl: '/overflowConfig/list',
  updateUrl: '/overflowConfig/update',
  deleteUrl: '/overflowConfig/delete',
  createUrl: '/overflowConfig/create',
  detailUrl: '/overflowConfig/detail',
};
